import { useCallback } from "react";

import * as MutationRepository from "../repository/mutation";

import type * as DiscountItemOrdinaryShared from "../../../_shared";

export const useCreateDiscountOrdinary = (
	inputModel: DiscountItemOrdinaryShared.Model.ModelType.DiscountOrdinaryFormModel["InputModel"],
) => {
	const { onCreateDiscountOrdinary: _onCreateDiscountOrdinary } =
		MutationRepository.useDiscountOrdinaryUpdateMutation();

	const onCreateDiscountOrdinary = useCallback(
		() => _onCreateDiscountOrdinary(inputModel),
		[_onCreateDiscountOrdinary, inputModel],
	);

	return {
		onCreateDiscountOrdinary,
	};
};
